module.exports = __webpack_public_path__ + "36e6c34cfd106fb35c599924cdfe499e.png";